<template>
  <v-container style="max-width:100%;padding:0;" fill-height>
    <v-layout column>
      <v-flex id="mapCtrls" xs12 sm12 md4 class="pb-2 ">
        <v-card elevation="8" style="padding: 5px;">
          <div class="card-style-title">
            Map visual
            <div class="btnCont">
              <iframe-modal :id="id" :src="src" :width="1700" :height="1000" />
              <v-btn
                depressed
                v-if="selected !== 'Scotland Temporary Counts'"
                rounded
                color="#00486b"
                style="color:#fff"
                width="5vw"
                :href="mapDatasetUrls"
                target="_blank"
              >
                Data
              </v-btn>
              <v-btn
                depressed
                v-if="selected === 'Scotland Temporary Counts'"
                rounded
                color="#00486b"
                style="color:#fff"
                width="5vw"
                :href="loadTempCountDataset"
                target="_blank"
              >
                Data
              </v-btn>
            </div>
          </div>
          <v-subheader>{{ selectedDesc }}</v-subheader>
          <v-container>
            <v-row>
              <v-col>
                <v-select
                  v-model="selected"
                  :items="mapDatasetLabels"
                  label="field name"
                  solo
                ></v-select>
                <v-card-text v-if="legends.length > 0">
                  <span style="padding-right: 10px">
                    Legend:
                  </span>
                  <span v-for="item in legends" :key="item.label">
                    <span :style="{ color: item.colour }" class="m-l-20 zmdi zmdi-circle"></span>
                    {{ item.label }}
                  </span>
                </v-card-text>
              </v-col>
              <datepicker
                v-if="selected !== 'Scotland Temporary Counts'"
                :year-range="yearRange"
                :data-type="dataType"
              />
              <v-col v-if="selected === 'Scotland Temporary Counts'">
                <v-select
                  v-model="selectedTempCount"
                  :items="tempCountDatasets"
                  label="field name"
                  solo
                >
                </v-select>
                <v-divider />
                <v-card-actions>
                  <v-spacer />
                  <v-btn depressed large color="primary" rounded @click="loadData">
                    Load
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-flex>
      <v-flex id="map" xs12 sm12 md12></v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable no-underscore-dangle */ // --> OFF
import Chart from 'ol-ext/style/Chart';
import Map from 'ol/Map';
import View from 'ol/View';
import Point from 'ol/geom/Point';
import * as proj from 'ol/proj';
import TileLayer from 'ol/layer/Tile';
import Feature from 'ol/Feature';
import { Vector, OSM, Cluster } from 'ol/source';
import LayerVector from 'ol/layer/Vector';
import Select from 'ol/interaction/Select';
import { defaults as defaultInteractions } from 'ol/interaction';
import { mapGetters, mapActions } from 'vuex';
import {
  Style, Stroke, Text, Fill, Circle,
} from 'ol/style';
import { register } from 'ol/proj/proj4';
import proj4 from 'proj4';
import XYZ from 'ol/source/XYZ';
import OlPopup from 'ol-ext/overlay/Popup';
import iframeModal from '@/components/iframeModal.vue';
import datepicker from './datepicker.vue';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'ol/ol.css';
import 'ol-ext/overlay/Popup.css';
import '../assets/css/material-design-iconic-font.min.css';

export default {
  name: 'CyclingScotlandMap',
  components: {
    datepicker,
    iframeModal,
  },
  data: () => ({
    id: 'mapvisual',
    src: 'mapvisual',
    dashboard: [],
    dataset: {},
    fetchedData: null,
    dataType: 3,
    picker: new Date().toISOString().substr(0, 10),
    features: [],
    map: null,
    activeVectorLayer: null,
    dataPoints: [],
    selected: 'Big Count Survey',
    selectedTempCount: '',
    popup: new OlPopup({
      popupClass: 'default',
      closeBox: true,
      positioning: 'bottom-left',
      offsetBox: [0, 65, 0, 0],
      autoPan: true,
      autoPanAnimation: { duration: 250 },
    }),
    select: new Select(),
    selectedDesc: '',
    legends: [
      {
        label: 'Pedestrian',
        code: 'PED',
        colour: '#ffa500',
      },
      {
        label: 'Bicycle',
        code: 'CYCLE',
        colour: 'blue',
      },
    ],
    counterLegend: [
      {
        label: 'Pedestrian',
        code: 'PED',
        colour: '#ffa500',
      },
      {
        label: 'Bicycle',
        code: 'CYCLE',
        colour: 'blue',
      },
    ],
    tempCounterLegend: [
      {
        icon: 'bike',
        label: 'Cyclist',
        colour: '#1a9641',
      },
      {
        icon: 'car',
        label: 'Car/Taxi',
        colour: '#f99e59',
      },
      {
        icon: 'truck',
        label: 'LGV/HGV',
        colour: '#ffedab',
      },
      {
        icon: 'bus',
        label: 'Bus/Coach',
        colour: '#c4e687',
      },
      {
        icon: 'bike',
        label: 'Motorcycle',
        colour: '#58b453',
      },
      {
        icon: 'walk',
        label: 'Pedestrian',
        colour: '#4366b7',
      },
    ],
    bigCountLegend: [
      {
        label: '0% - 5%',
        minValue: 0,
        maxValue: 5,
        colour: '#d7191c',
      },
      {
        label: '5% - 10%',
        minValue: 5,
        maxValue: 10,
        colour: '#e85b3a',
      },
      {
        label: '10% - 15%',
        minValue: 10,
        maxValue: 15,
        colour: '#f99e59',
      },
      {
        label: '15% - 20%',
        minValue: 15,
        maxValue: 20,
        colour: '#fec981',
      },
      {
        label: '20% - 25%',
        minValue: 20,
        maxValue: 25,
        colour: '#ffedab',
      },
      {
        label: '25% - 30%',
        minValue: 25,
        maxValue: 30,
        colour: '#ecf7ad',
      },
      {
        label: '30% - 35%',
        minValue: 30,
        maxValue: 35,
        colour: '#c4e687',
      },
      {
        label: '35% - 40%',
        minValue: 35,
        maxValue: 40,
        colour: '#97d265',
      },
      {
        label: '40% - 50%',
        minValue: 40,
        maxValue: 45,
        colour: '#58b453',
      },
      {
        label: '> 50%',
        minValue: 50,
        maxValue: 1000,
        colour: '#1a9641',
      },
    ],
    dftLegend: [
      {
        label: '0% - 0.05%',
        minValue: 0,
        maxValue: 0.05,
        colour: '#d7191c',
      },
      {
        label: '0.05% - 0.15%',
        minValue: 0.05,
        maxValue: 0.15,
        colour: '#e85b3a',
      },
      {
        label: '0.15% - 0.25%',
        minValue: 0.15,
        maxValue: 0.25,
        colour: '#f99e59',
      },
      {
        label: '0.25% - 0.35%',
        minValue: 0.25,
        maxValue: 0.35,
        colour: '#fec981',
      },
      {
        label: '0.35% - 0.45%',
        minValue: 0.35,
        maxValue: 0.45,
        colour: '#ffedab',
      },
      {
        label: '0.45% - 0.55%',
        minValue: 0.45,
        maxValue: 0.55,
        colour: '#ecf7ad',
      },
      {
        label: '0.55% - 0.65%',
        minValue: 0.55,
        maxValue: 0.65,
        colour: '#c4e687',
      },
      {
        label: '0.65% - 0.75%',
        minValue: 0.65,
        maxValue: 0.75,
        colour: '#97d265',
      },
      {
        label: '0.75% - 0.85%',
        minValue: 0.75,
        maxValue: 0.85,
        colour: '#58b453',
      },
      {
        label: '>0.85%',
        minValue: 0.85,
        maxValue: 10,
        colour: '#1a9641',
      },
    ],
    view: new View({
      center: proj.transform(
        [parseFloat('-4.298424'), parseFloat('56.238087')],
        'EPSG:4326',
        'EPSG:3857',
      ),
      zoom: 8,
    }),
    yearRange: ['2017', '2016', '2015', '2014', '2013', '2012'],
  }),
  computed: {
    ...mapGetters([
      'compositeDataset',
      'allDataPoints',
      'alltempCountDataPoints',
      'allBigCountDataPoints',
      'allDFTDataPoints',
    ]),
    mapDatasetLabels() {
      const d = this.compositeDataset;
      const dashboards = [];
      if (d && Object.keys(d).length > 0) {
        d.mapDatasets.forEach((mapDataset) => {
          dashboards.push(mapDataset.label);
        });
      }
      return dashboards;
    },
    tempCountDatasets() {
      const d = this.compositeDataset;
      const datasets = [];
      if (d && Object.keys(d).length > 0) {
        d.mapDatasets.forEach((mapDataset) => {
          if (mapDataset.label === 'Scotland Temporary Counts') {
            datasets.push(mapDataset.title);
          }
        });
      }
      return datasets;
    },
    mapDatasetUrls() {
      let d = null;
      if (this.compositeDataset && this.compositeDataset.mapDatasets) {
        this.compositeDataset.mapDatasets.forEach((mapDataset) => {
          if (mapDataset.label === this.selected) {
            d = mapDataset.dataset;
          }
        });
      }
      return d;
    },
    loadTempCountDataset() {
      let d = null;
      if (this.compositeDataset && this.compositeDataset.mapDatasets) {
        this.compositeDataset.mapDatasets.forEach((mapDataset) => {
          if (mapDataset.title === this.selectedTempCount && this.selected === mapDataset.label) {
            d = mapDataset.dataset;
          }
        });
      }
      return d;
    },
  },
  watch: {
    allDataPoints() {
      this.dataPoints = [];
      this.getCounterData(this.allDataPoints);
      this.initDataPoints();
    },
    alltempCountDataPoints() {
      this.dataPoints = [];
      this.getTempCounterData(this.alltempCountDataPoints);
      this.initTempDataPoints();
    },
    allBigCountDataPoints() {
      this.dataPoints = [];
      this.getBigCountData(this.allBigCountDataPoints);
      this.initBigCountGraph();
    },
    allDFTDataPoints() {
      this.dataPoints = [];
      this.getDFTData(this.allDFTDataPoints);
      this.initDFTGraph(this.dftLegend);
    },
    selected() {
      let datasets = [];
      this.features = [];
      this.dataPoints = [];
      this.popup.hide();
      this.map.removeLayer(this.activeVectorLayer);
      switch (this.selected) {
        case 'Department for Transport Traffic Counts':
          this.dataType = 2;
          this.selectedDesc = 'This data shows the percentage of road users that are cyclist at each traffic count location across Scotland.';
          this.legends = this.dftLegend;
          this.yearRange = [
            '2017',
            '2016',
            '2015',
            '2014',
            '2013',
            '2012',
            '2011',
            '2010',
            '2009',
            '2008',
            '2007',
            '2006',
          ];
          this.fetchDFTDataset().then(() => {
            const data = JSON.parse(JSON.stringify(this.allDFTDataPoints));
            this.getDFTData(data);
            this.initDFTGraph(this.dftLegend);
          });
          break;
        case 'Big Count Survey':
          this.dataType = 3;
          this.selectedDesc = 'Every year, twice a year, Cycling Scotland asks people all across Scotland to visit the bike parking at their work and count how many bikes are there on that day. The results can be viewed here as an average for each year.';
          this.legends = this.bigCountLegend;
          this.yearRange = ['2017', '2016', '2015', '2014', '2013', '2012'];
          this.fetchBigCountDataset().then(() => {
            const data = JSON.parse(JSON.stringify(this.allBigCountDataPoints));
            this.getBigCountData(data);
            this.initBigCountGraph();
          });
          break;
        case 'Scotland Temporary Counts': {
          this.dataType = 1;
          this.selectedDesc = 'A range of datasets that provides a list of Cycling Scotland’s temporary counters.';
          datasets = this.fetchtempCountDatasetTitles();
          [this.selectedTempCount] = datasets;
          let dataset = null;
          if (this.compositeDataset && this.compositeDataset.mapDatasets) {
            this.compositeDataset.mapDatasets.forEach((mapDataset) => {
              if (
                mapDataset.title === this.selectedTempCount
                && this.selected === mapDataset.label
              ) {
                dataset = mapDataset.apiResource;
              }
            });
          }
          this.fetchTempCounterData(dataset).then(() => {
            const data = JSON.parse(JSON.stringify(this.alltempCountDataPoints));
            this.getTempCounterData(data);
            this.initTempDataPoints();
            this.legends = this.tempCounterLegend;
          });
          break;
        }
        case 'Cycling Scotland Counters - real-time data feed':
          this.dataType = 1;
          this.selectedDesc = 'This dataset is a real-time feed from all of Cycling Scotland’s Automatic Cycling Counter. A date range can be selected to analyse the data.';
          this.fetchLiveCounter({ picker1: '', picker: '' }).then(() => {
            const data = JSON.parse(JSON.stringify(this.allDataPoints));
            this.picker1 = data.minDate[0].max;
            this.getCounterData(data);
            this.initDataPoints();
            this.legends = this.counterLegend;
          });
          break;
        default:
          this.dataType = 1;
          this.selectedDesc = 'This dataset is a real-time feed from all of Cycling Scotland’s Automatic Cycling Counter. A date range can be selected to analyse the data.';
          this.fetchLiveCounter({ picker1: '', picker: '' }).then(() => {
            const data = JSON.parse(JSON.stringify(this.allDataPoints));
            this.getCounterData(data);
            this.initDataPoints();
            this.legends = this.counterLegend;
          });
      }
    },
  },
  mounted() {
    const { popup } = this;
    this.map = new Map({
      target: 'map',
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        new TileLayer({
          source: new XYZ({
            url: 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          }),
        }),
      ],
      overlays: [popup],
      view: this.view,
      interactions: defaultInteractions({
        mouseWheelZoom: false,
      }),
    });
    this.map.addInteraction(this.select);

    proj4.defs(
      'EPSG:27700',
      '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 +units=m +no_defs',
    );
    register(proj4);
  },
  created() {
    // this.fetchLiveCounter({ picker1: "", picker: "" }).then(() => {
    //   const data = JSON.parse(JSON.stringify(this.allDataPoints));
    //   this.getCounterData(data);
    //   this.initDataPoints();
    // });
    this.dataType = 3;
    this.legends = this.bigCountLegend;
    this.selectedDesc = 'Every year, twice a year, Cycling Scotland asks people all across Scotland to visit the bike parking at their work and count how many bikes are there on that day. The results can be viewed here as an average for each year.';
    this.yearRange = ['2017', '2016', '2015', '2014', '2013', '2012'];
    this.fetchBigCountDataset().then(() => {
      const data = JSON.parse(JSON.stringify(this.allBigCountDataPoints));
      this.getBigCountData(data);
      this.initBigCountGraph();
    });
  },
  methods: {
    ...mapActions([
      'fetchLiveCounter',
      'fetchDFTDataset',
      'fetchBigCountDataset',
      'fetchTempCounterData',
    ]),
    fetchtempCountDatasetTitles() {
      return this.tempCountDatasets;
    },
    loadData() {
      let dataset = null;
      if (this.compositeDataset && this.compositeDataset.mapDatasets) {
        this.compositeDataset.mapDatasets.forEach((mapDataset) => {
          if (mapDataset.title === this.selectedTempCount && this.selected === mapDataset.label) {
            dataset = mapDataset.apiResource;
          }
        });
      }
      this.fetchTempCounterData(dataset).then(() => {
        const data = JSON.parse(JSON.stringify(this.alltempCountDataPoints));
        this.getTempCounterData(data);
        this.initTempDataPoints();
        this.legends = this.tempCounterLegend;
      });
    },
    initTempDataPoints() {
      this.features = [];
      const { tempCounterLegend } = this;
      this.map.removeLayer(this.activeVectorLayer);
      const { popup } = this;
      this.select = null;
      this.select = new Select({
        // eslint-disable-next-line no-unused-vars
        style(feature, resolution) {
          const radius = 30;
          const data = feature.get('data');
          const sum = data.reduce((accumulator, currentValue) => accumulator + currentValue);
          const styleArr = [
            new Style({
              image: new Chart({
                type: 'donut',
                colors: ['#1a9641', '#f99e59', '#ffedab', '#c4e687', '#58b453', '#4366b7'],
                rotateWithView: true,
                data,
                radius,
                stroke: new Stroke({
                  color: '#fff',
                  width: 2,
                }),
              }),
            }),
          ];
          let s = 0;
          for (let i = 0; i < data.length; i += 1) {
            const d = data[i];
            const a = ((2 * s + d) / sum) * Math.PI - Math.PI / 2;
            const v = Math.round((d / sum) * 1000);
            if (v > 0) {
              styleArr.push(
                new Style({
                  text: new Text({
                    text: /* (v/10)+"%", */ d.toString(),
                    offsetX: Math.cos(a) * (radius + 3),
                    offsetY: Math.sin(a) * (radius + 3),
                    textAlign: a < Math.PI / 2 ? 'left' : 'right',
                    textBaseline: 'middle',
                    stroke: new Stroke({
                      color: '#fff',
                      width: 3,
                    }),
                    fill: new Fill({
                      color: '#333',
                    }),
                  }),
                }),
              );
            }
            s += d;
          }
          return styleArr;
        },
      });
      this.map.addInteraction(this.select);
      this.dataPoints.forEach((point) => {
        const latLongCoord = [parseFloat(point.lng), parseFloat(point.lat)];
        const googleCoord = proj.transform(latLongCoord, 'EPSG:4326', 'EPSG:3857');
        this.createFeature(googleCoord, point.data);
      });
      // cycleValue,
      // pedValue,
      // carValue + taxiValue,
      // lgvValue + hgvValue,
      // serviceBusValue + coachValue,
      // mCycleValue
      this.select.getFeatures().on(['add'], (e) => {
        const feature = e.element;
        let content = '';
        const total = feature.values_.data.reduce((a, b) => a + b, 0);
        const percentage = (feature.values_.data[0] / total) * 100;
        content += `<div class='row symbolPopup' style="width: 380px;align-items: center;">
        <div class='col-5'">
          <i class='zmdi zmdi-bike large'></i>
            <div class='percentage'>${percentage.toFixed(2)}%
            </div>
        </div>
        <div class="col-7">`;
        tempCounterLegend.forEach((item, index) => {
          content += `<div class='row'><div class='col-3'><i class='zmdi zmdi-${item.icon}'></i></div><div class='col-9'><div>${item.label}: ${feature.values_.data[index]}</div></div></div>`;
        });
        content += '</div></div>';
        popup.offsetBox = [0, 35, 0, 0];
        popup.show(feature.getGeometry().getFirstCoordinate(), content);
      });
      this.select.getFeatures().on(['remove'], () => {
        popup.hide();
      });
      const style = function getStyle(feature) {
        return this.graphFeatureStyle(feature, true);
      }.bind(this);
      this.activeVectorLayer = this.createVectorLayer(this.features, style);
      this.map.addLayer(this.activeVectorLayer);
      //
    },
    initDataPoints() {
      this.features = [];
      this.map.removeLayer(this.activeVectorLayer);
      const { popup } = this;
      this.select = null;
      this.select = new Select({
        // eslint-disable-next-line no-unused-vars
        style(feature, resolution) {
          const radius = 20;
          const data = feature.get('data');
          const sum = data.reduce((accumulator, currentValue) => accumulator + currentValue);
          const styleArr = [
            new Style({
              image: new Chart({
                type: 'donut',
                colors: ['#ffa500', 'blue'],
                rotateWithView: true,
                data,
                radius,
                stroke: new Stroke({
                  color: '#fff',
                  width: 2,
                }),
              }),
            }),
          ];
          let s = 0;
          for (let i = 0; i < data.length; i += 1) {
            const d = data[i];
            const a = ((2 * s + d) / sum) * Math.PI - Math.PI / 2;
            const v = Math.round((d / sum) * 1000);
            if (v > 0) {
              styleArr.push(
                new Style({
                  text: new Text({
                    text: /* (v/10)+"%", */ d.toString(),
                    offsetX: Math.cos(a) * (radius + 3),
                    offsetY: Math.sin(a) * (radius + 3),
                    textAlign: a < Math.PI / 2 ? 'left' : 'right',
                    textBaseline: 'middle',
                    stroke: new Stroke({
                      color: '#fff',
                      width: 3,
                    }),
                    fill: new Fill({
                      color: '#333',
                    }),
                  }),
                }),
              );
            }
            s += d;
          }
          return styleArr;
        },
      });
      this.map.addInteraction(this.select);
      this.dataPoints.forEach((point) => {
        const latLongCoord = [parseFloat(point.lat), parseFloat(point.lng)];
        const googleCoord = proj.transform(latLongCoord, 'EPSG:4326', 'EPSG:3857');
        this.createFeature(googleCoord, point.data);
      });
      this.select.getFeatures().on(['add'], (e) => {
        const feature = e.element;
        let content = '';
        const total = feature.values_.data.reduce((a, b) => a + b, 0);
        const percentage = (feature.values_.data[1] / total) * 100;
        content += `<div class="row symbolPopup" style="width: 380px;"><div class="col-5"><i class="zmdi zmdi-bike large"></i><div class="percentage">${percentage.toFixed(
          1,
        )}%</div></div><div class="col-7"><div class="row"><div class="col-3"><i class="zmdi zmdi-bike"></i></div><div class="col-9"><div>Cyclist: ${
          feature.values_.data[1]
        }</div></div></div><div class="row"><div class="col-3"><i class="zmdi zmdi-walk"></i></div><div class="col-9"><div>Pedestrian: ${
          feature.values_.data[0]
        }</div></div></div></div></div>`;
        popup.offsetBox = [0, 65, 0, 0];
        popup.show(feature.getGeometry().getFirstCoordinate(), content);
      });
      this.select.getFeatures().on(['remove'], () => {
        popup.hide();
      });
      const style = function getStyle(feature) {
        return this.graphFeatureStyle(feature);
      }.bind(this);
      this.activeVectorLayer = this.createVectorLayer(this.features, style);
      this.map.addLayer(this.activeVectorLayer);
    },
    createFeature(coords, data) {
      // creates a feature and adds it to track
      const feature = new Feature({
        geometry: new Point(coords),
        data,
      });
      this.features.push(feature);
    },
    graphFeatureStyle(feature, temp) {
      let colors = ['#1a9641', '#f99e59', '#ffedab', '#c4e687', '#58b453', '#4366b7'];
      if (!temp) colors = ['#ffa500', 'blue'];
      const radius = 30;
      const data = feature.get('data');
      const sum = data.reduce((accumulator, currentValue) => accumulator + currentValue);
      const styleArr = [
        new Style({
          image: new Chart({
            type: 'donut',
            rotateWithView: true,
            colors,
            data,
            radius,
            stroke: new Stroke({
              color: '#fff',
              width: 2,
            }),
          }),
        }),
      ];
      let s = 0;
      for (let i = 0; i < data.length; i += 1) {
        const d = data[i];
        const a = ((2 * s + d) / sum) * Math.PI - Math.PI / 2;
        const v = Math.round((d / sum) * 1000);
        if (v > 0) {
          styleArr.push(
            new Style({
              text: new Text({
                text: /* (v/10)+"%", */ d.toString(),
                offsetX: Math.cos(a) * (radius + 3),
                offsetY: Math.sin(a) * (radius + 3),
                textAlign: a < Math.PI / 2 ? 'left' : 'right',
                textBaseline: 'middle',
                stroke: new Stroke({
                  color: '#fff',
                  width: 3,
                }),
                fill: new Fill({
                  color: '#333',
                }),
              }),
            }),
          );
        }
        s += d;
      }
      return styleArr;
    },
    createVectorLayer(features, fetchStyle, cluster) {
      const src = new Vector({ features });
      const clusterSrc = new Cluster({
        distance: 60,
        source: src,
      });
      const layer = new LayerVector({
        source: cluster ? clusterSrc : src,
        style: fetchStyle,
      });
      return layer;
    },
    getCounterData(data) {
      const { pedestrian, bicycle } = data;
      pedestrian.forEach((agg) => {
        Object.keys(agg).forEach((lat) => {
          Object.keys(agg[lat]).forEach((lng) => {
            const record = pedestrian[0];
            const pedValue = record[lat][lng].Count_sum !== undefined
              ? record[lat][lng].Count_sum : 0;
            const cycleValue = bicycle[0][lat][lng].Count_sum !== undefined
              ? bicycle[0][lat][lng].Count_sum : 0;
            this.dataPoints.push({
              lng,
              lat,
              data: [pedValue, cycleValue],
            });
          });
        });
      });
    },
    getTempCounterData(data) {
      const {
        car, taxi, lgv, hgv, serviceBus, coach, mCycle, cyclist, pedestrian,
      } = data;
      pedestrian.forEach((agg) => {
        Object.keys(agg).forEach((lat) => {
          Object.keys(agg[lat]).forEach((lng) => {
            const record = pedestrian[0];
            const pedValue = record[lat][lng].Pedestrian_sum !== undefined
              ? record[lat][lng].Pedestrian_sum : 0;
            const carValue = car[0][lat][lng].Car_sum !== undefined ? car[0][lat][lng].Car_sum : 0;
            const cycleValue = cyclist[0][lat][lng].Cyclist_sum !== undefined
              ? cyclist[0][lat][lng].Cyclist_sum : 0;
            const taxiValue = taxi[0][lat][lng].Taxi_sum !== undefined
              ? taxi[0][lat][lng].Taxi_sum : 0;
            const lgvValue = lgv[0][lat][lng].LGV_sum !== undefined ? lgv[0][lat][lng].LGV_sum : 0;
            const hgvValue = hgv[0][lat][lng].HGV_sum !== undefined ? hgv[0][lat][lng].HGV_sum : 0;
            const serviceBusValue = serviceBus[0][lat][lng].ServiceBus_sum !== undefined
              ? serviceBus[0][lat][lng].ServiceBus_sum
              : 0;
            const coachValue = coach[0][lat][lng].Coach_sum !== undefined
              ? coach[0][lat][lng].Coach_sum : 0;
            const mCycleValue = mCycle[0][lat][lng]['M/Cycle_sum'] !== undefined
              ? mCycle[0][lat][lng]['M/Cycle_sum']
              : 0;
            this.dataPoints.push({
              lng,
              lat,
              data: [
                cycleValue,
                carValue + taxiValue,
                lgvValue + hgvValue,
                serviceBusValue + coachValue,
                mCycleValue,
                pedValue,
              ],
            });
          });
        });
      });
    },
    getDFTData(rawData) {
      this.dataPoints = [];
      const aggregation = rawData;
      aggregation.forEach((northKey) => {
        Object.keys(northKey).forEach((northing) => {
          Object.keys(northKey[northing]).forEach((easting) => {
            const record = rawData[0];
            const bicycles = record[northing][easting].PedalCycles_sum
              ? record[northing][easting].PedalCycles_sum
              : 0;
            const motorVehicles = record[northing][easting].AllMotorVehicles_sum
              ? record[northing][easting].AllMotorVehicles_sum
              : 0;
            const percentage = (bicycles / (bicycles + motorVehicles)) * 100;
            const cyclingPercentage = percentage.toFixed(2);
            this.dataPoints.push({
              lng: parseFloat(easting),
              lat: parseFloat(northing),
              data: [bicycles, motorVehicles, cyclingPercentage],
            });
          });
        });
      });
    },
    getBigCountData(rawData) {
      this.dataPoints = [];
      rawData.forEach((agg) => {
        Object.keys(agg).forEach((lat) => {
          Object.keys(agg[lat]).forEach((lng) => {
            Object.keys(agg[lat][lng]).forEach((postcode) => {
              const record = rawData[0];
              const staffSum = record[lat][lng][postcode].staff_sum
                ? record[lat][lng][postcode].staff_sum
                : 0;
              const bikesSum = record[lat][lng][postcode].bikes_sum
                ? record[lat][lng][postcode].bikes_sum
                : 0;
              this.dataPoints.push({
                lng,
                lat,
                data: [staffSum, bikesSum, postcode, bikesSum / staffSum],
              });
            });
          });
        });
      });
    },
    initDFTGraph(dftLegend) {
      this.features = [];
      this.map.removeLayer(this.activeVectorLayer);
      const { popup } = this;
      this.select = null;
      this.select = new Select({
        // eslint-disable-next-line no-unused-vars
        style(feature, resolution) {
          function getColor(data) {
            let chosenColor = '#000000';
            const percentage = data[2];
            dftLegend.forEach((item) => {
              if (percentage >= item.minValue && percentage < item.maxValue) {
                chosenColor = item.colour;
              }
            });
            return chosenColor;
          }
          const style = new Style({
            image: new Circle({
              radius: 6,
              stroke: new Stroke({
                color: 'white',
                width: 2,
              }),
              fill: new Fill({
                color: getColor(feature.get('data')),
              }),
            }),
          });

          return [style];
        },
      });
      this.select.getFeatures().on(['add'], (e) => {
        const feature = e.element;
        let content = '';
        const percentage = feature.get('data')[2];
        content += `<b>AllMotorVehicles sum:</b> ${
          feature.get('data')[1]
        }<br><b>PedalCycles sum:</b> ${
          feature.get('data')[0]
        }<br><b>cycling_percentage:</b> ${percentage}%`;
        popup.offsetBox = [0, 20, 0, 0];
        popup.show(feature.getGeometry().getFirstCoordinate(), content);
      });
      this.map.addInteraction(this.select);

      this.dataPoints.forEach((point) => {
        const latLongCoord = [parseFloat(point.lng), parseFloat(point.lat)];
        const googleCoord = proj.transform(latLongCoord, 'EPSG:27700', 'EPSG:3857');
        this.createDFTFeature(googleCoord, point.data);
      });
      const style = function getStyle(feature) {
        return this.getDfTStyle(feature, this.dftLegend);
      }.bind(this);
      this.activeVectorLayer = this.createVectorLayer(this.features, style);
      this.map.addLayer(this.activeVectorLayer);
    },
    initBigCountGraph() {
      this.features = [];
      this.map.removeLayer(this.activeVectorLayer);
      const { popup, bigCountLegend } = this;
      this.select = null;
      this.select = new Select({
        style(cluster) {
          const features = cluster.get('features');
          let size = 0;
          const values = [];
          function getColor(data) {
            let chosenColor = '#007e27';
            const percentage = data * 100;
            bigCountLegend.forEach((item) => {
              if (percentage >= item.minValue && percentage < item.maxValue) {
                chosenColor = item.colour;
              }
            });
            return chosenColor;
          }
          features.forEach((feature) => {
            const data = feature.get('data');
            const percentage = (data[1] / data[0]) * 100;
            const val = parseFloat(percentage).toFixed(2);
            values.push(Number(val));
          });
          size = values.reduce((accumulator, currentValue) => accumulator + currentValue);
          const avg = (size / values.length).toFixed(2);
          let fillColor = avg;
          if (cluster.get('features').length === 1) {
            // eslint-disable-next-line prefer-destructuring
            fillColor = cluster.get('features')[0].values_.data[3];
          }
          const style = new Style({
            image: new Circle({
              radius: 20,
              stroke: new Stroke({
                color: '#666666',
                width: 2,
              }),
              fill: new Fill({
                color: getColor(fillColor),
              }),
            }),
            text: new Text({
              text: `${avg}%`,
              fill: new Fill({
                color: 'black',
              }),
            }),
          });

          return [style];
        },
      });
      const { view } = this;
      this.select.getFeatures().on(['add'], (e) => {
        const feature = e.element;
        let content = '';
        if (feature.values_.features.length === 1) {
          const countValues = feature.values_.features[0].values_;
          const percentage = (countValues.data[1] / countValues.data[0]) * 100;
          content += `<div class="row symbolPopup" style="width: 380px;"><div class="col-5"><i class="zmdi zmdi-bike large"></i><div class="percentage">${percentage.toFixed(
            1,
          )}%</div></div><div class="col-7"><div class="row"><div class="col-3"><i class="zmdi zmdi-bike"></i></div><div class="col-9"><div>Bicycle Count: ${
            countValues.data[1]
          }</div></div></div><div class="row"><div class="col-3"><i class="zmdi zmdi-male-female"></i></div><div class="col-9"><div>Staff Count: ${
            countValues.data[0]
          }</div></div></div><div class="row"><div class="col-3"><i class="zmdi zmdi-map"></i></div><div class="col-9"><div>Postcode Area: ${
            countValues.data[2]
          }</div></div></div></div></div>`;
          popup.offsetBox = [0, 20, 0, 0];
          view.animate({
            center: feature.getGeometry().getFirstCoordinate(),
            duration: 1500,
          });
          popup.show(feature.getGeometry().getFirstCoordinate(), content);
        } else {
          view.animate({
            zoom: view.getZoom() + 1,
            center: feature.getGeometry().getFirstCoordinate(),
            duration: 1500,
          });
        }
      });
      this.map.addInteraction(this.select);
      this.dataPoints.forEach((point) => {
        const latLongCoord = [parseFloat(point.lng), parseFloat(point.lat)];
        const googleCoord = proj.transform(latLongCoord, 'EPSG:4326', 'EPSG:3857');
        this.createDFTFeature(googleCoord, point.data);
      });
      const style = function getStyle(feature) {
        return this.getClusterStyle(feature, this.bigCountLegend);
      }.bind(this);
      this.activeVectorLayer = this.createVectorLayer(this.features, style, true);
      this.map.addLayer(this.activeVectorLayer);
    },
    createDFTFeature(googleCoord, data) {
      this.features.push(
        new Feature({
          geometry: new Point(googleCoord),
          data,
        }),
      );
    },
    getDfTStyle(feature, legend) {
      function getColor(data) {
        let chosenColor = '#000000';
        const percentage = data[2];
        legend.forEach((item) => {
          if (percentage >= item.minValue && percentage < item.maxValue) {
            chosenColor = item.colour;
          }
        });
        return chosenColor;
      }
      const style = new Style({
        image: new Circle({
          radius: 6,
          stroke: new Stroke({
            color: 'white',
            width: 2,
          }),
          fill: new Fill({
            color: getColor(feature.get('data')),
          }),
        }),
      });

      return [style];
    },
    getClusterStyle(cluster, legend) {
      const features = cluster.get('features');
      let size = 0;
      const values = [];
      function getColor(data) {
        let chosenColor = '#007e27';
        const percentage = data;
        legend.forEach((item) => {
          if (percentage >= item.minValue && percentage < item.maxValue) {
            chosenColor = item.colour;
          }
        });
        return chosenColor;
      }
      features.forEach((feature) => {
        const data = feature.get('data');
        const percentage = (data[1] / data[0]) * 100;
        const val = parseFloat(percentage).toFixed(2);
        values.push(Number(val));
      });
      size = values.reduce((accumulator, currentValue) => accumulator + currentValue);
      const avg = (size / values.length).toFixed(2);
      const style = new Style({
        image: new Circle({
          radius: 20,
          stroke: new Stroke({
            color: '#666666',
            width: 2,
          }),
          fill: new Fill({
            color: getColor(avg),
          }),
        }),
        text: new Text({
          text: `${avg}%`,
          fill: new Fill({
            color: 'black',
          }),
        }),
      });

      return [style];
    },
  },
};
</script>

<style>
@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
  /* IE10+ specific styles go here */
  #mapCtrls {
    position: relative;
    margin-bottom: 18rem;
  }
}
.ol-popup.default {
  border: initial !important;
  -webkit-filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  filter: drop-shadow(0 1px 4px rgba(0, 0, 0, 0.2));
  padding: 30px 15px 15px 15px;
  border-radius: 10px;
}
.ol-popup .closeBox {
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 150%;
  padding: 0 4px;
  color: gray;
  text-decoration: none;
  background-color: initial !important;
}
.ol-popup .closeBox:hover {
  color: #011520;
  text-decoration: none;
}
.symbolPopup i.large {
  font-size: 80px;
}
.symbolPopup .percentage {
  font-size: 30px;
}
.symbolPopup i {
  font-size: 20px;
}
.symbolPopup .col-3 {
  padding-bottom: 5px;
  padding-top: 5px;
}
.symbolPopup .col-5 {
  padding-bottom: 5px;
  padding-top: 5px;
}
.symbolPopup .col-7 {
  padding-bottom: 5px;
  padding-top: 5px;
}
.symbolPopup .col-9 {
  padding-bottom: 5px;
  padding-top: 5px;
}
</style>
